import * as React from "react"
import {TabsSeeker} from "@ui-seeker/core";

import { LabelCountry } from "@components";
import { PriceEvolutionCurrentTabId, PriceEvolutionCurrentTabData } from "../../@signals";
import PriceEvolutionTabsMiniImageSku from "./MiniImageSku";


export default function PriceEvolutionTabs({ tabs, isSplitBySku }) {

    return <TabsSeeker
		showTabID={PriceEvolutionCurrentTabId.value?.toString()}
		onChange={(_, newValue) => PriceEvolutionCurrentTabData.value = tabs.filter(tab => tab.id.toString() === newValue)[0]}
		tabs={tabs.map(({ label, id, country }) => ({
			label: label,
			value: id.toString(),
			iconPosition: 'top',
			icon: isSplitBySku
				? <PriceEvolutionTabsMiniImageSku name={label} skuID={id} />
				: <LabelCountry country={country} />
		}))}
		tabProps={{
            sx:{
				p: .5,
				borderBottom: '2px solid',
				borderColor: "primary.lighter",
				minWidth: 250,
				textTransform: 'none'
			}
        }}
	/>
}